import { 
    RejectRequestActionTypes,
    RejectRequestState,
    RejectRequestActions,
 } from "./reject-request.types";

 const INITIAL_STATE: RejectRequestState = {
    isRejected: false,
    isDeleting: false,
    rejectErrorMessage: null,
 };

 const rejectRequestReducer = (state: any = INITIAL_STATE, action: RejectRequestActions) => {
     switch (action.type) {
        case RejectRequestActionTypes.REJECT_REQUEST_START:
            return {
                ...state,
                isDeleting: true,
            };
        case RejectRequestActionTypes.REJECT_REQUEST_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                isRejected: action.payload.isRejected,
            };
        case RejectRequestActionTypes.REJECT_REQUEST_FAILURE:
            return {
                ...state,
                isDeleting: false,
                rejectErrorMessage: action.payload.errorMessage,
            };
        default:
            return state;
     }
 };

 export default rejectRequestReducer;
 